// @ts-check
import SmrClient from "Utils/Requests/SmrClient";

class SettingsRequests {
    /**
     * @returns {Promise<GetOtherSettingsResponse>}
     */
    async GetOtherSettings() {
        return await SmrClient.FetchJson({
            url: 'settings/GetOtherSettings',
            method: 'GET'
        });
    }

    /**
     * @returns {Promise<GetUsersServerSettingsResponse>}
     */
    async GetUsersServerSettings() {
        return await SmrClient.FetchJson({
            url: 'Settings/GetUsersServerSettings',
            method: 'GET'
        });
    }

    /**
     * @param {ExportClientsLogsRequest} dataToSend
     * @returns {Promise<ValueResponse<ExportDocumentPrepareDownloadFileTask>>}
     */
    async ExportLogsTaskRun(dataToSend) {
        return await SmrClient.FetchJson({
            url: 'settings/ExportLogsTaskRun',
            method: "POST",
            body: dataToSend
        });
    }

    /**
     * @returns {Promise<ConverterSettings>}
     */
    async GetConverterSettings() {
        return await SmrClient.FetchJson({
            url: 'settings/GetConverterSettings',
            method: 'GET'
        });
    }

    /**
     * @returns {Promise<IntegrationSettings>}
     */
    async GetIntegrationSettings() {
        return await SmrClient.FetchJson({
            url: 'settings/GetIntegrationSettings',
            method: 'GET'
        });
    }

    /**
     * @param {SaveRestrictionSettingsRequest} dataToSend 
     * @returns {Promise<SaveRestrictionSettingsResponse>}
     */
    async SaveRestrictionSettings(dataToSend) {
        return await SmrClient.FetchJson({
            url: 'settings/SaveRestrictionSettings',
            method: "POST",
            body: dataToSend
        });
    }

    /**
     * @param {SaveMaxFileSizeRequest} dataToSend 
     * @returns {Promise<SaveMaxFileSizeResponse>}
     */
    async SaveMaxFileSizeSetting(dataToSend) {
        return await SmrClient.FetchJson({
            url: 'settings/SaveMaxFileSize',
            method: "POST",
            body: dataToSend
        });
    }

    /**
     * @param {OtherSettings} dataToSend 
     * @returns {Promise<VoidResponse>}
     */
    async SaveOtherSettings(dataToSend) {
        return await SmrClient.FetchJson({
            url: 'settings/SaveOtherSettings',
            method: "POST",
            body: dataToSend
        });
    }

    /**
     * @param {boolean} settingValue
     */
    async SaveSettingCbProtocolShowBoxRecords(settingValue) {
        await SmrClient.FetchJson({
            url: 'settings/SaveSettingCbProtocolShowBoxRecords',
            method: "POST",
            body: { settingValue: settingValue },
            bodyIsUrlParams: true
        });
    }

    /**
     * @returns {Promise<SendTestEmailResponse>}
     */
    async SendTestEmail() {
        return await SmrClient.FetchJson({
            url: 'settings/SendTestEmail',
            method: 'GET'
        });
    }

    /**
     * @param {SaveUsersServerSettingsRequest} dataToSend 
     * @returns {Promise<SaveUsersServerSettingsResponse>}
     */
    async SaveUsersServerSettings(dataToSend) {
        return await SmrClient.FetchJson({
            url: 'Settings/SaveUsersServerSettings',
            method: "POST",
            body: dataToSend
        });
    }

    /**
     * @returns {Promise<GetClientLogsSubDirectoriesListResponse>}
     */
    async GetClientLogsSubDirectoriesList(clientLogsSubDirectoriesListFilter) {
        return await SmrClient.FetchJson({
            url: 'settings/GetClientLogsSubDirectoriesList',
            method: 'POST',
            body: clientLogsSubDirectoriesListFilter
        });
    }

    /**
     * @param {ConverterSettings} dataToSend 
     * @returns {Promise<VoidResponse>}
     */
    async SaveConverterSettings(dataToSend) {
        return await SmrClient.FetchJson({
            url: 'settings/SaveConverterSettings',
            method: "POST",
            body: dataToSend
        });
    }

    /**
     * @param {IntegrationSettings} dataToSend 
     * @returns {Promise<VoidResponse>}
     */
    async SaveIntegrationSettings(dataToSend) {
        return await SmrClient.FetchJson({
            url: 'settings/SaveIntegrationSettings',
            method: "POST",
            body: dataToSend
        });
    }

    /**
     * @param {SyncSyncedUsersRequest} dataToSend 
     * @returns {Promise<SyncSyncedUsersResponse>}
     */
    async SyncSyncedUsers(dataToSend) {
        return await SmrClient.FetchJson({
            url: 'settings/SyncSyncedUsers',
            method: "POST",
            body: dataToSend
        });
    }

    /**
     * @returns {Promise<WebMigrationStatus>}
     */
    async StartMigration() {
        return await SmrClient.FetchJson({
            url: 'settings/StartMigration',
            method: "GET"
        });
    }
}

export default new SettingsRequests;